<template>
  <div class="form-search-mobil" id="form-search-mobil">
    <form class="form-search-mobil__block" @submit.prevent="search">
      <input type="search"
             placeholder="Search..."
             :value="searchQuery"
             @input.trim="({target}) => setSearchQuery(target.value)"
      />
      <input
            type="reset"
            value=""
            @click="removeSearchQuery"
    />
    </form>
    <div class="form-search__bg-close"></div>
    <div class="search-result"
         :class="{active: searchResult.length}"
    >
      <ul>
        <li v-for="{id, title, slug, category} in searchResult" :key="id">
          <a :href="`${lang_prefix}/${category.parent.slug}/${category.slug}/${slug}`">{{$lang(title)}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Search',
  computed: {
    ...mapGetters('search', ['searchResult', 'searchQuery', 'loading']),
    lang_prefix () {
      return this.$currentLang === 'ru' ? '/ru' : ''
    },
  },
  methods: {
    ...mapMutations('search', ['removeSearchQuery']),
    ...mapActions('search', ['setSearchQuery', 'search']),
  },
}
</script>

<style scoped lang="scss">
  .navbar {
    &.search-open-mobil {
      .search-result.active {
        opacity: 1;
      }
      .form-search-mobil{
        overflow: visible;
      }
    }

    .search-result {
      z-index: 100;
      padding: 1rem;
      opacity: 0;
      overflow: scroll;
      max-height: 600px;
      transition: all 0.2s ease-in-out;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background-color: #fff;
    }
  }
</style>
